export class NumberFormatService {
    /**
     * Formats a price for display with locale-appropriate grouping (e.g. 1,518.00)
     * instead of compact suffixes like 1.518K. Always shows two decimal places
     * (700 -> 700.00, 700.1 -> 700.10).
     */
    formatNumberWithCountingLabel(price: number, languageCode: string): string {
        const rounded = Math.round(price * 100) / 100;
        return rounded.toLocaleString(languageCode, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    }
}
